<template>
  <div>
    <Header ref="header" id="class0"/>
    <section class="banner" ref="banner">
      <div class="container flex flex_between flex_center">
      <div class="banner_text">
        <h1>凝聚知名专家智库力量 <br>
          致力于信用资本价值实现</h1>
        <p>牢牢把握国内外最新信用发展形势 <br>
          始终保持前沿理论与先进实践良好互动</p>
      </div>
      <img src="@/assets/class/banner_img.png" alt="">
    </div>
    </section>
    <section class="class_content">
      <div class="container">
        <section>
          <h2 class="content_title">首席专家寄语</h2>
          <div class="teacher flex flex_between">
            <img src="@/assets/class/teacher.png" class="teacher_img">
            <div class="teacher_info">
              <h6 class="teacher_name">吴晶妹教授</h6>
              <p class="teacher_text">中国人民大学教授、博士生导师，信用管理学科带头人，信用领域顶级专家，从事信用研究三十余年</p>
              <img src="@/assets/class/douhao1.png">
              <p class="teacher_con">当今中国，信用已逐渐成为一种资本，成为优化社会资源配置的新要素，信用事业前景非凡。在“十四五”的开局之年，衷心希望与各位同仁携手，努力为我国社会信用体系建设这一造福子孙的宏伟大计贡献一份力量，为我国在新时代实现高质量发展探索提供来自信用领域的解决方案。</p>
            </div>
          </div>
        </section>

        <section class="class_wrap_box">
          <h2 class="content_title">年度重点课题项目</h2>
          <ul class="class_wrap flex flex_wrap flex_between">
            <template  v-for="item in classList">
              <li class="class_item" :id="`class${item.id}`" @click="item.select=!item.select">
                <div class="class_item_content" :class="{click:item.select}">
                  <template v-if="!flag">
                    <p class="select_btn" v-if="!item.select">点击选择</p>
                  </template>
                  <img :src="require(`@/assets/class/item${item.id}@2x.png`)" alt="">
                  <div class="item_conten" :class="{textIndent:item.id==14}">
                    <h6>{{ item.title }}</h6>
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </li>
            </template>

          </ul>
        </section>
      </div>
    </section>

    <section class="input_info" :class="{'fixed':fixed}">
      <div class="container">
        <template v-if="flag">
          <section class="form_submit flex flex_between flex_center">
            <p class="submit_title_flag flex flex_center"><img src="@/assets/class/input_icon@2x.png" alt="">年度重点课题  紧跟信用前沿</p>
            <div class="submit_flag">
              <span>对上述课题项目感兴趣？快戳 >></span>
              <button class="submit" @click="flag = !flag">课题详情</button>
            </div>
          </section>
        </template>
        <template v-else>
          <section class="form_submit flex flex_between flex_center">
          <p class="submit_title">选择感兴趣的课题，并留下联系 <br>
            方式，我们将在第一时间联系您</p>
          <div class="input_bg">
            <label><span>*</span> 您的称呼:</label>
            <input type="text" style="width: 62px;" v-model="name">
          </div>
          <div class="input_bg">
            <label><span>*</span> 联系方式:</label>
            <input type="text" style="width: 125px;" v-model="mobile">
          </div>
          <div class="input_bg">
            <label>公司/单位全称:</label>
            <input type="text" style="width: 150px;" v-model="company">
          </div>
          <button class="submit" @click="submit">提交</button>
          <p class="tips">* 项不可为空</p>
          </section>
        </template>

      </div>
    </section>

    <section>
      <div class="container">
        <h2 class="content_title">点滴风采</h2>
        <ul class="fengcai flex flex_between">
          <li class="fengcai_item">
            <img src="@/assets/class/fengcai0.png" alt="">
            <p>业务足迹遍布24个省级行政区</p>
          </li>
          <li class="fengcai_item">
            <img src="@/assets/class/fengcai1.png" alt="">
            <p>汇聚顶尖专家精英，倾心为国家部委、地方政府、行业协会、广大企业提供信用研究、咨询、培训服务</p>
          </li>
        </ul>
      </div>
    </section>
    <section class="section_contact">
      <div class="container">
        <Contact />
      </div>
    </section>
    <SuccessModal ref="success"/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Contact from "@/components/Contact";
import SuccessModal from "@/components/Success";
import { data } from "./data";
import { submitXinyongInfo } from "@/api";
import "@/js/message";

export default {
  name: "index",
  components:{
    Header,Contact,SuccessModal
  },
  data(){
    return{
      classList:data,
      fixed:false,
      flag:true,
      name:null,
      mobile:null,
      company: '',
      activeId:0,
      regs:/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/,
      reg:/^[1-9]+[0-9]*]*$/,
      phoneNum: /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/,
    }
  },
  watch:{
    '$route.params.id':function () {
      this.goScroll();
    }
  },
  mounted(){
    window.addEventListener("scroll",this.handleScroll);
    this.goScroll();
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop >= 410&&scrollTop < 1510) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    goScroll(){
      let id = this.$route.params.id;
      this.activeId = id;
      setTimeout(()=>{
        document.getElementById(`class${id}`).scrollIntoView(
          {
            behavior: "smooth",  // 平滑过渡
            block: "start",  // 上边框与视窗顶部平齐。默认值
          }
        );
      },300)
      this.selectItem(id);
    },

    selectItem(id) {
      this.classList.forEach(item => {
        if(item.select==true){
          item.select = false;
        }
      });
      this.classList.filter(item => {
        if (item.id == id) {
          item.select = true
        }
      })
    },
    submit(){
      console.log(this.name);
      // if(!this.name || this.reg.test(this.form.name) || this.regs.test(this.form.name) || this.name.length<2){
      if(!this.name || this.name.length<2){
        toast({msg:'请输入正确的称呼!',type:'warning',time:3e3});
        return
      }
      if(!this.mobile || !(this.phoneNum.test(this.mobile))){
        toast({msg:'请输入正确的联系方式!',type:'warning',time:3e3});
        return
      }

      let needs=[];
      this.classList.map(item=>{
        if(item.select==true){
          needs.push(item.title)
        }
      });
      let data = {
        name: this.name,
        phone: this.mobile,
        needs: needs.toString().replace(/,/g,'|'),
        company: this.company,
        // type:0
      }
      submitXinyongInfo(data).then(res => {
        if(res.code==1){
          this.flag = true;
          this.name = null;
          this.mobile = null;
          this.company = '';
          this.activeId = 0;
          this.$refs.success.showModal();
          setTimeout(()=>{
            this.$refs.success.hideModal();
          },2e3)
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
  .fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .banner{
    background: url("../../assets/class/bg0.png") 50% 0 no-repeat;
    background-size: cover;
    padding: 60px 0 40px;
    box-sizing: border-box;
    .banner_text{
      color: #fff;
      h1{
        font-size: 44px;
        font-weight: 500;
      }
      p{
        font-size: 16px;
        margin-top: 40px;
        line-height: 1.8;
      }
    }
    img{
      width: 305px;
    }
  }
  .content_title{
    font-size: 34px;
    padding: 60px 0 40px;
    font-weight: 500;
  }
  .class_content{
    background: url("../../assets/class/bg1.png") 0 0 no-repeat;
    background-size: 100%;

    .teacher{
      margin-bottom: 20px;
      .teacher_img{
        width: 163px;
      }
      .teacher_info{
        width: calc(100% - 21px);
        padding-left: 47px;
        .teacher_name{
          font-size: 22px;
          font-weight: 500;
          line-height: 1;
        }
        .teacher_text{
          font-size: 14px;
          line-height: 1;
          margin: 12px 0 20px;
        }
        img{
          width: 28px;
          display: block;
        }
        .teacher_con{
          padding: 0 60px 10px 60px;
          font-size: 18px;
          text-indent: 2em;
          background:url("../../assets/class/douhao2.png") 100% 100% no-repeat;
          background-size: 28px;
          line-height: 2;
          margin: -9px 0;
        }
      }
    }
    .class_wrap_box{
      .content_title{
        padding-bottom: 20px;
      }
    }
    .class_wrap{
      box-sizing: border-box;
      .class_item{
        width: calc(33.33% - 28px);
        .class_item_content{
          margin: 20px 0;
          background: #F3F3F3;
          padding: 30px;
          position: relative;
          transition: all .3s;
          cursor: pointer;
          box-sizing: border-box;
          position: relative;
          height: 186px;
          .select_btn{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 3;
            width: 90px;
            height: 90px;
            text-align: center;
            font-size: 22px;
            border-radius: 50%;
            color: #fff;
            padding: 20px;
            box-sizing: border-box;
            background: rgba(0, 82, 147, .8);
            line-height: 1.2;
            transition: all ease .3s;
            &:hover{
              background: rgba(0, 82, 147, 1);
            }
          }
          &.click{
            background: #005293;
            color: #fff;
            h6{
              color: #fff;
            }
          }
        }
        .item_conten{
          position: relative;
          z-index: 2;
          h6{
            font-size: 22px;
            color: #005293;
            margin-bottom: 25px;
            font-weight: 500;
          }
          p{
            font-size: 16px;
            line-height: 1.6;
            text-align: justify;
          }
          &.textIndent{
            p{
              letter-spacing: -.5px;
            }
          }
        }
        &:nth-child(3n){
          margin-right: 0;
        }
        img{
          position: absolute;
          bottom:0;
          right:0;
          display: block;
        }
      }
    }
  }
  .input_info{
    background: url("../../assets/class/input_bg@2x.png") 0 0 no-repeat;
    background-size: cover;
    height: 72px;
    margin-top: 25px;
  }
  .form_submit{
    /*background: #F3F3F3;
    box-shadow: 0 -3px 3px 0px rgba(0,0,0,.08);*/
    position: relative;
    height: 72px;
    .submit_title_flag{
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      img{
        display: block;
        width: 40px;
        margin-right: 15px;
      }
    }
    .submit_flag{
      span{
        background: #C18620;
        border-radius: 16px;
        font-size: 18px;
        color: #fff;
        padding: 2px 18px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .submit_title{
      height: 100%;
      box-sizing: border-box;
      padding: 12px 28px;
      background: #C18620;
      font-size: 16px;
      color: #fff;
    }
    .input_bg{
      padding-left: 18px;
      padding-top: 2px;
      label{
        font-size: 18px;
        color: #815815;
        span{
          /*color: #E30000;*/
          color: #fff;
        }
      }
      input{
        border-bottom: 1px solid #815815;
        font-size: 20px;
      }
    }
    .submit{
      display: inline-block;
      padding: 0 36px;
      height: 72px;
      background: #005293;
      text-align: center;
      /*line-height: 71px;*/
      color: #fff;
      font-size: 18px;
      margin-left: 15px;
      transition: all ease .3s;
      &:hover{
        background:rgba(0,82,147,.8)
      }
      &:active{
        background:rgba(0,82,147,1)
      }
    }
    .tips{
      position: absolute;
      right:-80px;
      top:50%;
      transform: translate(0, -50%);
      font-size: 12px;
      color: #fff;
    }
  }
  .fengcai{
    margin-bottom: 47px;
    .fengcai_item{
      position: relative;
      img{
        display: block;
      }
      p{
        position: absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 40px;
        background: rgba(0, 82, 147, .8);
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
</style>
